module.exports = __webpack_public_path__ + "img/64.0b5fe375.jpg";